<template>
    <b-modal id="sendEmailModal" centered modal-class="modal-garden-help modal-confirm-message">
        <div class="d-block mb-2">
            <input id="quote_id" name="quote_id" type="hidden" v-model="quote_id" />
            <input id="client" name="client" type="hidden" v-model="client_name" />
            <!-- <img src="@/assets/images/garden-help/close-circle.png" class="close-img" /> -->
            <h4 class="title-confirm-modal ">Send Payment URL Email</h4>
            <p class="message-confirm-modal text-center my-3 ">
                Are you sure you want to send the payment URL email ?
            </p>
        </div>

        <template class="justify-content-center mt-5" #modal-footer>
            <b-row class="justify-content-center w-100 m-0">
                <b-col lg="4" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-danger-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="closeModalSend">
                        Cancel
                    </b-button>
                </b-col>
                <b-col lg="4" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        v-if="!is_loading" @click="clickConfirmSend">
                        Yes, Send
                    </b-button>
                    <b-button type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help  mb-1 w-100" v-else>
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>

            </b-row>
        </template>
    </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
    name: "SendPaymentEmail",
    props: ["client_name", "quote_id"],
    data() {
        return {
            is_loading: false,
        };
    },

    mounted() { },

    methods: {
        clickConfirmSend() {
            console.log("in confirm send email ", this.client_name, this.quote_id);

            this.is_loading = true;
            let requestData = {
                client: this.client_name,
                invoice_id: this.quote_id
            }
            let formData = new FormData()
            formData.append("invoice_id", this.quote_id)
            axios
                .post(
                    "payment/invoice/send-payment-email",
                    formData,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            withCredentials: false,
                            client: this.client_name,
                            Authorization:
                                "Bearer " +
                                JSON.parse(window.localStorage.getItem("user")).access_token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    this.is_loading = false;
                    this.$fire({
                        text: response.data.success,
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },

                    }).then((r) => {
                        this.$bvModal.hide("sendEmailModal");
                        this.$router.push({ name: "GardenHelpMyJobs", query: { type: 'quotes' } });
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.is_loading = false;

                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 5000,
                    }).then((r) => {
                    });
                });

        },
        closeModalSend() {
            this.$bvModal.hide("sendEmailModal");
        },
    },
};
</script>
        


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/SendPaymentURLModal.vue